import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';

import ReleaseNotesList from './ReleaseNotesList';
import { useAutoTranslation } from 'src/hooks/useTranslate';

/**
 * The all-user "What's new" panel: the release history of the build they are
 * running, newest first.
 *
 * Deliberately read-only and free of any update controls — taking an update is
 * an administrator's decision and lives in Settings → Updates.
 */
const WhatsNewDialog = ({ open, onClose, releases, loading }) => {
  const t = useAutoTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="whats-new-title"
      slotProps={{ paper: { sx: { borderRadius: '12px' } } }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 3,
          pt: 2.5,
          pb: 1
        }}
      >
        <Typography id="whats-new-title" variant="h6" sx={{ fontWeight: 700 }}>
          {t("What's new")}
        </Typography>
        <IconButton onClick={onClose} size="small" aria-label={t('Close')}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent sx={{ px: 3, pb: 3, pt: 1 }}>
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 2 }}>
            <CircularProgress size={16} />
            <Typography sx={{ color: 'text.secondary' }}>
              {t('Loading release notes…')}
            </Typography>
          </Box>
        ) : (
          <ReleaseNotesList
            releases={releases}
            emptyMessage={t(
              'No release notes have been published for this version yet.'
            )}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default WhatsNewDialog;
